export const stemiConsultationsTranslations = {
    en: {
        // Page Title
        mukhyamantriHridaySanjivani: "Mukhyamantri Hriday Sanjivani",
        consultationsFor: "Consultations for",
        allCampaigns: "All Campaigns",

        // Table Headers
        srNo: "Sr. No.",
        tokenNo: "Token No",
        beneficiaryName: "Beneficiary Name",
        presentingSymptoms: "Presenting Symptoms",
        ecgFindings: "ECG Findings",
        remark: "Remark",
        action: "Action",

        // Buttons
        addConsultation: "Add Consultation",
        viewProfile: "View Profile",

        // Status
        campCompleted: "Camp Completed",

        // Drawer Titles
        addMmhsConsultation: "Add Mukhyamantri Hriday Sanjivani Consultation",
        viewMmhsConsultation: "View Mukhyamantri Hriday Sanjivani Consultation",

        // Common
        notAvailable: "N/A",
        unknown: "Unknown",

        // Module Name
        mmhsConsultationsModule: "Mukhyamantri Hriday sanjivani Consultations",
    },
    mr: {
        // Page Title
        mukhyamantriHridaySanjivani: "मुख्यमंत्री हृदय संजीवनी",
        consultationsFor: "साठी सल्लामसलत",
        allCampaigns: "सर्व मोहिमा",

        // Table Headers
        srNo: "अ. क्र.",
        tokenNo: "टोकन क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        presentingSymptoms: "सादर लक्षणे",
        ecgFindings: "ECG निष्कर्ष",
        remark: "शेरा",
        action: "क्रिया",

        // Buttons
        addConsultation: "सल्लामसलत जोडा",
        viewProfile: "प्रोफाइल पहा",

        // Status
        campCompleted: "शिबिर पूर्ण झाले",

        // Drawer Titles
        addMmhsConsultation: "मुख्यमंत्री हृदय संजीवनी सल्लामसलत जोडा",
        viewMmhsConsultation: "मुख्यमंत्री हृदय संजीवनी सल्लामसलत पहा",

        // Common
        notAvailable: "उपलब्ध नाही",
        unknown: "अज्ञात",

        // Module Name
        mmhsConsultationsModule: "मुख्यमंत्री हृदय संजीवनी सल्लामसलत",
    }
};
